import styled from 'styled-components';

import { device } from 'styles/breakpoints';

export const FooterWrapper = styled.footer``;

export const FooterTopWrapper = styled.div`
  margin-bottom: 80px;
  display: flex;
  justify-content: center;
  > div {
    display: grid;
    grid-template-areas:
      'f1 f2'
      'f3 f2';
    column-gap: 110px;
  }
  .footer {
    &-logo {
      grid-area: f1;
      display: flex;
    }
    &-nav {
      grid-area: f2;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(1, 1fr);
      gap: 80px;
      &-col {
        > p {
          color: ${({ theme }) => theme.colors.grayPallet10};
          margin-bottom: 20px;
        }
        > div {
          display: flex;
          flex-direction: column;
          gap: 16px;

          > a {
            display: flex;
            &:hover {
              text-decoration: underline;
            }
            > p {
              color: ${({ theme }) => theme.colors.bluePallet1};
            }
          }
        }
      }
    }
    &-alt {
      grid-area: f3;
      max-width: 220px;
      margin-top: 64px;
      > p {
        color: ${({ theme }) => theme.colors.grayPallet10};
      }
    }
  }
  @media ${device.laptop} {
    margin-bottom: 0;
    > div {
      grid-template-areas:
        'f1'
        'f2'
        'f3';
      padding: 60px 40px;
    }
    .footer {
      &-logo {
        margin-bottom: 52px;
      }
      &-nav {
        gap: 24px;
      }
      &-alt {
        max-width: unset;
      }
    }
  }
  @media ${device.tablet} {
    > div {
      padding: 80px 20px;
    }
    .footer {
      &-logo {
        margin-bottom: 40px;
      }
      &-nav {
        column-gap: 20px;
        row-gap: 28px;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        &-col {
          > div {
            gap: 12px;
          }
        }
      }
      &-alt {
        max-width: unset;
      }
    }
  }
`;

export const FooterBottom = styled.div`
  background-color: ${({ theme }) => theme.colors.bluePallet1};
  padding-top: 100px;
  padding-bottom: 80px;
  display: flex;
  justify-content: center;
  .top {
    padding-bottom: 45px;
    border-bottom: 2px solid #637d95;
    > p {
      color: ${({ theme }) => theme.colors.white};
      &:last-child {
        margin-top: 20px;
      }
    }
  }
  .bottom {
    margin-top: 30px;
    > p {
      color: ${({ theme }) => theme.colors.bluePallet7};
    }
  }
  @media ${device.laptop} {
    padding-top: 60px;
    padding-bottom: 60px;
    .top {
      padding-bottom: 20px;
    }
    .bottom {
      margin-top: 20px;
    }
  }
`;
